import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";
import Container from "@components/Atomic/Container/Container";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import React from "react";
import tw from "twin.macro";
import { FeaturedCollectionCarousel } from "./FeaturedCollectionCarousel";
import { withFeaturedCollection } from "./withFeaturedCollection";

const OuterWrapper = withFocusRing(tw.div`
  relative py-maxi smd:pb-tera
`);
const TabHeader = withFocusRing(tw.div`
  flex mt-micro items-baseline md:mt-zero
`);
const Title = withFocusRing(
  styledWithInvalidProps("button")(({ active }) => [
    tw`ml-mini leading-caption cursor-pointer font-medium hover:text-secondary hover:opacity-100 first:ml-zero`,
    active ? tw`border-b` : tw`opacity-60`,
  ]),
);

export const FeaturedCollection = withFeaturedCollection(
  ({
    autoDelay,
    heading,
    styles,
    featuredCollectionContents,
    tabTitle,
    handlePromoClick,
    handleTabClick,
    activeTab,
    _key,
  }) => (
    <Container
      styles={styles}
      data-component-type="section-featured-collection"
    >
      <OuterWrapper tabIndex={0}>
        <div className="flex flex-col pl-midi md:absolute md:z-10 md:flex-row md:items-center xl:pl-tera">
          <div className="rte mr-midi">{heading}</div>
          {tabTitle && tabTitle.length > 0 ? (
            <TabHeader>
              {tabTitle.map(({ title }) => (
                <Title
                  key={`${title}-${_key}`}
                  active={activeTab === title}
                  onClick={() => handleTabClick(title)}
                  role="tab"
                  aria-selected={`${activeTab}_${_key}` === `${title}_${_key}`}
                  id={`${title?.toLowerCase()}_${_key}`}
                >
                  {title}
                </Title>
              ))}
            </TabHeader>
          ) : null}
        </div>
        <FeaturedCollectionCarousel
          _key={_key}
          autoDelay={autoDelay}
          activeTab={activeTab}
          featuredCollectionContents={featuredCollectionContents}
          handleClick={handlePromoClick}
        />
      </OuterWrapper>
    </Container>
  ),
);
